import EDC from '../../../shared/globals';
import DotBox from '../dot-box';
import AnswersBox from '../answers-box';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

/**
 *
 */
EDC.Games.CountingDots.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.CountingDots, 17]);

  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.difficulty = 1;
  this.iteration = 0;
  this.dotBox = null;
  this.answersBox = null;
  this.isDotsDisappeared = false;
  this.isAnswersDisappeared = false;
  this.signals = {
    S_DOTS_DISAPPEARED: 'S_DOTS_DISAPPEARED',
    S_ALL_ANSWERS_DISAPPEARED: 'S_ANSWERS_DISAPPEARED',
    S_ANSWER_DISAPPEARED: 'S_ANSWER_DISAPPEARED',
    S_ANSWER_CORRECT_CLICKED: 'S_ANSWER_CORRECT_CLICKED',
    S_ANSWER_WRONG_CLICKED: 'S_ANSWER_WRONG_CLICKED',
  };
};
/**
 *
 */
EDC.Games.CountingDots.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CountingDots.Scenes.Main.prototype.constructor = EDC.Games.CountingDots.Scenes.Main;
/**
 *
 */
EDC.Games.CountingDots.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.createBaseStructure();
  this.loadIterationIfAvailable();

  this.createBasicUI();
};

EDC.Games.CountingDots.Scenes.Main.prototype.createBaseStructure = function () {
  this.add.sprite(this.game.scale.width / 2, 1020, 'label-title');

  this.dotBox = new DotBox(this).create(this.game.scale.width / 2, 350);
  this.answersBox = new AnswersBox(this).create(700);

  this.events.on(this.signals.S_DOTS_DISAPPEARED, this.onDotsDisappeared, this);
  this.events.on(this.signals.S_ALL_ANSWERS_DISAPPEARED, this.onAnswersDisappeared, this);
  this.events.on(this.signals.S_ANSWER_WRONG_CLICKED, this.onWrongAnswer, this);
  this.events.on(this.signals.S_ANSWER_CORRECT_CLICKED, this.onCorrectAnswer, this);

  this.isDotsDisappeared = true;
  this.isAnswersDisappeared = true;
};

EDC.Games.CountingDots.Scenes.Main.prototype.loadIterationIfAvailable = function () {
  if (this.isDotsDisappeared && this.isAnswersDisappeared) {
    this.loadIteration();
  }
};
/**
 *
 */
EDC.Games.CountingDots.Scenes.Main.prototype.onWrongAnswer = function () {
  this.playWrong();
};
/**
 *
 */
EDC.Games.CountingDots.Scenes.Main.prototype.onCorrectAnswer = function () {
  this.playCorrect();
  this.answersBox.hideAnswers();
  this.dotBox.disappearDots();
  this.iteration = this.iteration + 1;
};
/**
 *
 */
EDC.Games.CountingDots.Scenes.Main.prototype.onDotsDisappeared = function () {
  this.isDotsDisappeared = true;
  this.loadIterationIfAvailable();
};
/**
 *
 */
EDC.Games.CountingDots.Scenes.Main.prototype.onAnswersDisappeared = function () {
  this.isAnswersDisappeared = true;
  this.loadIterationIfAvailable();
};
/**
 *
 */
EDC.Games.CountingDots.Scenes.Main.prototype.loadIteration = function () {
  this.isDotsDisappeared = false;
  this.isAnswersDisappeared = false;

  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    const data = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
    this.dotBox.generateDots(data.correctAnswer);
    this.answersBox.updateData(data.choices, data.correctAnswer);
  }
};

export default EDC.Games.CountingDots.Scenes.Main;
